export const AUTH_REQUIRED_EVENT = 'zqcf:auth-required'

export function emitAuthRequired(code) {
    if (typeof window === 'undefined') {
        return
    }

    const detail = { code: Number(code) }
    let event
    if (typeof window.CustomEvent === 'function') {
        event = new window.CustomEvent(AUTH_REQUIRED_EVENT, { detail })
    } else {
        event = document.createEvent('CustomEvent')
        event.initCustomEvent(AUTH_REQUIRED_EVENT, true, true, detail)
    }
    window.dispatchEvent(event)
}

export function subscribeAuthRequired(listener) {
    if (typeof window === 'undefined') {
        return () => {}
    }

    const handler = event => listener(event.detail || {})
    window.addEventListener(AUTH_REQUIRED_EVENT, handler)
    return () => window.removeEventListener(AUTH_REQUIRED_EVENT, handler)
}
